"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlan = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var core_1 = require("../../../shared/core");
var mapping_1 = require("./mapping");
var usePlan = function (accountId) {
    var kapi = core_1.configService.getConfig().kapi;
    var kapiEnabled = kapi && kapi.plan ? true : false;
    var _a = (0, kapi_1.usePlanV1Query)({
        variables: {
            accountId: accountId,
        },
        skip: !kapiEnabled,
    }), kapiData = _a.data, kapiLoading = _a.loading, kapiError = _a.error;
    var plansQueryResult = (0, legacy_queries_1.usePlansLegacyQuery)(accountId, {
        enabled: !kapiEnabled,
    });
    var _b = (0, legacy_queries_1.useSupplyPoints)(accountId), supplyPointsData = _b.data, supplyPointsLoading = _b.loading, supplyPointsError = _b.error;
    var legacyLoading = plansQueryResult.isFetching || supplyPointsLoading;
    var legacyError = plansQueryResult.status === 'error'
        ? plansQueryResult.error
        : supplyPointsError
            ? supplyPointsError
            : undefined;
    var data = kapiData
        ? (0, mapping_1.mapPlanQueryKapiV1ToPlanCX)(kapiData)
        : plansQueryResult.status === 'data' && supplyPointsData
            ? (0, mapping_1.mapPlanLegacyResponseToPlanCX)(plansQueryResult.data, supplyPointsData)
            : null;
    return {
        loading: kapiLoading || legacyLoading,
        error: kapiError || legacyError,
        data: data,
    };
};
exports.usePlan = usePlan;
